import { Controller, useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { validationMessages } from 'constants/validation'

const {
  Required,
  TooLongLength,
  TooShortLength
} = validationMessages

import {
  Stack,
  TextField,
} from '@mui/material'

import { Section } from 'components/controls/section'

import { GroupFormData, GroupResult } from 'interface/user/group'

const formSchema = yup.object().shape({
  groupName: yup.string().required(Required)
    .min(2, TooShortLength(5))
    .max(20, TooLongLength(20)),
  effectiveTime: yup.string().nullable(),
})

type useGroupFormProps = {
  group?: GroupResult
  onSubmit: (body: GroupFormData) => void
}
export const useGroupForm = ({
  group,
  onSubmit
}: useGroupFormProps) => {
  const form = useForm({
    defaultValues: group ? {
      groupName: group.groupName,
      effectiveTime: group.effectiveTime
    } : {
      groupName: '',
      effectiveTime: ''
    },
    mode: 'onChange',
		resolver: yupResolver(formSchema)
  })
  return {
    ...form,
    group,
    submit: form.handleSubmit(input => onSubmit({
      groupName: input.groupName,
      effectiveTime: input.effectiveTime ?? ''
    }))
  }
}

export const GroupForm = ({
  control,
  formState: { isValid, errors }
}: ReturnType<typeof useGroupForm>) => (
  <Stack direction="column">
    <Section label="グループ名" labelProps={{ py: 2 }}>
      <Controller
        control={control}
        name="groupName"
        render={({ field }) => (
          <TextField
            {...field}
            variant="outlined"
            size="small"
            error={!isValid}
            helperText={errors.groupName ? errors.groupName.message : ''}
          />
        )}
      />
    </Section>
  </Stack>
)
